export default __webpack_public_path__ + "static/m_main_hero-d9639e6bb03f7d5ddc60abe5e8cd1f9c.png";